const author = {
  user: {
    completeName: 'Antonio Pérez',
    name: 'Antonio',
    userlastname: 'Perez',
    userImg: '/crops/dog'
  },
  association: {
    name: 'Periodista',
    associationImg: '/crops/rabbit'
  }
};

const author2 = {
  user: {
    completeName: 'Antonio Pérez',
    name: 'Antonio',
    userlastname: 'Perez',
    userImg: '/crops/dog',
    username: 'Ant5654'
  },
  association: {
    name: 'Periodista',
    associationImg: '/crops/rabbit'
  }
};

export { author, author2 };
